import { restClient as restClientHttp } from '../../../axios';
import { RestClientFacade } from '../../../axios/rest.model';
import Util from '../../../util/Util';

import * as callTypes from './ModuleCallTypes';

export class ModuleCalls {
  readonly workSpaceManagementServiceURL =
    new Util().getWorkSpaceManagementServiceURL();

  constructor(private restClient: RestClientFacade = restClientHttp) {}

  getModule(moduleName: string): Promise<boolean> {
    const url = `${
      this.workSpaceManagementServiceURL
    }/module/assigned/${encodeURIComponent(moduleName)}`;
    return this.restClient
      .callPromise<Record<string, boolean>>(
        {
          url,
          method: 'GET',
        },
        callTypes.getModule
      )
      .then((data) => data[moduleName]);
  }

  getSelfModule(moduleName: string): Promise<boolean> {
    const url = `${
      this.workSpaceManagementServiceURL
    }/module/self/${encodeURIComponent(moduleName)}`;
    return this.restClient
      .callPromise<Record<string, boolean>>(
        {
          url,
          method: 'GET',
        },
        callTypes.getModule
      )
      .then((data) => data[moduleName]);
  }
}
